import { getStore } from '../store/stores-repository'
import { APP_BAR_STORE } from '../store/stores'
import { getRouteName, MONITORING, NOT_FOUND, VIOLATION_LOG } from './app-routes'

export const notFoundRouteChangeHandler = {
    routeMatcher: /^\/404\/?$/,
    onEnter: () => {
        const appBarStore = getStore(APP_BAR_STORE)
        appBarStore.updateState({ title: getRouteName(NOT_FOUND) })
    }
}

// Pages handlers
export const monitoringPageHandler = {
    routeMatcher: /^(\/|(\/monitoring))$/,
    onEnter: () => {
        const appBarStore = getStore(APP_BAR_STORE)
        appBarStore.updateState({ title: getRouteName(MONITORING) })
    }
}

export const violationLogPageHandler = {
    routeMatcher: /^\/violation-log$/,
    onEnter: () => {
        const appBarStore = getStore(APP_BAR_STORE)
        appBarStore.updateState({ title: getRouteName(VIOLATION_LOG) })
    }
}

export const ROUTE_CHANGE_HANDLERS = [
    monitoringPageHandler,
    violationLogPageHandler,
    notFoundRouteChangeHandler,
]
